// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.searchArea[data-v-44d290dc]{\n  align-items: normal !important;\n}\n[data-v-44d290dc] .tbl-type01.style03\nth {\n    background: #ececec !important;\n}\n[data-v-44d290dc] .type3{\n    border: 1px solid lightgray;\n}\n[data-v-44d290dc] tr.v-data-table__selected {\n    background:  lightgray !important;\n}\n[data-v-44d290dc] .form-select.v-text-field--outlined .v-select__selections{\n  display: flex !important;\n}\n", ""]);
// Exports
module.exports = exports;
